import { CREDIT_SCORES } from './CurrentDocument';


export default CREDIT_SCORES;
